export default {
  default: {
    paragraph: 'This project has no share links created. You can create a digital page which will automatically generate proofing and tracking links',
    title: "You haven't created any share links",
  },
}
